/**
 * @import { Place } from '@/features/world-map/types/place'
 */

import { usePlaces as usePlacesApi } from '@/features/world-map/api/get-places';
import { useFiltersContext } from '../context/filters';

const initialPlaces = /** @type {Place[]} */ ([]);

export function usePlaces() {
  const { filters } = useFiltersContext();
  const queryPlaces = usePlacesApi(filters);
  return queryPlaces.isSuccess ? queryPlaces.data : initialPlaces;
}
